<div class="container">
  <div class="card"
       *ngIf="true">
    <h2 class="heading">Thank you for submitting an application</h2>

    <span class="text">We are currently reviewing your application. We will reach out to you once our review is complete</span>
</div>